import React from 'react'
import { RouteStatus } from 'common/routing/RouteStatus'
import { PerthNowPageNotFound } from './PerthNowPageNotFound'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const PerthNowPageNotFoundRegistration = createRegisterableComponent(
    'page-not-found',
    () => (
        <RouteStatus statusCode={404}>
            <PerthNowPageNotFound />
        </RouteStatus>
    )
)
